
import request from '@/utils/server'
  // 列表
  export function getRequiredMaterials(query) {
    return request({
      url: '/procurement/getPurchaseOrderList',
      method: 'get',
     params: query
    })
  }
  // 新增采购单
 export function addPurchaseOrder(data) {
    return request({
      url: '/procurement/addPurchaseOrder',
      method: 'POST',
 data:data
    })
  }
  // 修改采购单
   export function editPurchaseOrder(data) {
    return request({
      url: '/procurement/editPurchaseOrder',
      method: 'POST',
 data:data
    })
  }
  // 删除
   export function deletePurchaseOrder(data) {
    return request({
      url: '/procurement/deletePurchaseOrder',
      method: 'POST',
 data:data
    })
  }
  // 获取采购食材
   export function getMaterialByNo(query) {
    return request({
      url: '/procurement/getMaterialByNo',
      method: 'get',
     params: query
    })
  }

  // 新增物料
    export function addPurchaseMaterial(data) {
    return request({
      url: '/procurement/addPurchaseMaterial',
      method: 'POST',
 data:data
    })
  }
  // 修改
   export function editPurchaseMaterial(data) {
    return request({
      url: '/procurement/editPurchaseMaterial',
      method: 'POST',
 data:data
    })
  }
  // 删除
   export function deletePurchaseMaterial(data) {
    return request({
      url: '/procurement/deletePurchaseMaterial',
      method: 'POST',
 data:data
    })
  }
  // 生成采购
  export function calculateLis(data) {
    return request({
      url: '/production/calculateLis',
      method: 'POST',
 data:data
    })
  }
  // 发起采购
  export function publishBidding(data) {
    return request({
      url: '/procurement/publishBidding',
      method: 'POST',
 data:data
    })
  } 